import FxxlCore from '@fxxl/core';
import jQueryEase from '@fxxl/jquery_ease';
import {setup as autocompleteSetup} from '@fxxl/autocomplete';
autocompleteSetup();
/**
 * Form Uploader Drag & Drop
 *
 * Filename: 400_rma_form_upload.js
 *
 * @category  Applicas
 * @package   RMA Upload
 * @author    Kevin Topf <k.topf@fahrrad-xxl.de>
 * @copyright 2020 Fahrrad XXL GmbH & Co. KG
 */

var FxxlisAdvancedUpload = function ()
{
    var div = document.createElement('div');
    return ( ( 'draggable' in div ) || ( 'ondragstart' in div && 'ondrop' in div ) ) && 'FormData' in window && 'FileReader' in window;
}();

function FxxlLoadUpload()
{
    $('.fxxl-rma-upload-form').each(function () {
        var form = $(this),
            input = form.find('input[type="file"]'),
            pos_id = form.data('pos-id'),
            container = $('.fxxl-rma-upload-container[data-pos-id="'+pos_id+'"]'),
            element_id = container.data('id'),
            droppedFiles = false;

        input.on('change', function (e) {
            droppedFiles = this.files;
            form.trigger('submit');
        });

        if (FxxlisAdvancedUpload) {
            form.addClass('has-advanced-upload');
            container.addClass('has-advanced-upload');

            container.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });

            container.on('dragover dragenter', function () {
                container.addClass('is-dragover');
            });

            container.on('dragleave dragend drop', function () {
                container.removeClass('is-dragover');
            });

            container.on('drop', function (e) {
                if (e.target.file) {
                    droppedFiles = e.target.file;
                } else if (e.dataTransfer) {
                    droppedFiles = e.dataTransfer.files;
                } else {
                    droppedFiles = e.originalEvent.dataTransfer.files;
                }
                form.trigger('submit');
            });

            container.on('click', function ( e ) {
                input.trigger('click');
            });
        }

        form.on('submit', function (e) {

            if ( FxxlisAdvancedUpload ) {
                e.preventDefault();

                var tmpData = form.get(0);
                if (droppedFiles) {
                    Array.prototype.forEach.call(droppedFiles, function ( file ) {

                        var mimeTypes = $('.fxxl-rma-upload-form__file').attr('accept');
                        if (mimeTypes.search(file.type) < 0 || file.size > 3145728) {
                            var uploadInfo = $('.fxxl-person-rma-address__upload-inf');
                            var errorText = uploadInfo.data('errorFileType');
                            if (file.size > 3145728) {
                                errorText = uploadInfo.data('errorFileSize');
                            }
                            M.toast({
                                html: errorText,
                                classes: 'fxxl-toast',
                                displayLength: 2500
                            });

                            return;
                        }

                        var unique_id = '-' + Math.floor(Math.random() * 10000);
                        var ajaxData = new FormData();

                        Array.prototype.forEach.call(tmpData, function ( el ) {
                            if ( input.attr('name') !== el.name ) {
                                ajaxData.append( el.name, el.value );
                            }
                        });

                        ajaxData.append(input.attr('name'), file);
                        var new_file = $("#" + element_id + "-showroom__example").clone();
                        new_file.appendTo("#" + element_id + "-showroom");
                        new_file.attr('id', element_id + '-showroom__entry-' + unique_id);
                        new_file.removeClass('fxxl-hidden');
                        new_file.find("input[type=hidden]").attr('name', 'uploaded_files_use['+pos_id+'][]');
                        new_file.find("input[type=hidden]").
                        attr('id', element_id + '-showroom__entry--uploaded_file' + unique_id);
                        new_file.find("input[type=hidden]").val(file.name);
                        new_file.find(".fxxl-rma-upload-showroom__entry--name").text(file.name);

                        new_file.find(".fxxl-rma-upload-showroom__entry--delete").on('click', function (e) {
                            new_file.remove();
                        });

                        $('.fxxl-person-rma-address').animate({
                            scrollTop: new_file.offset().top
                        }, 2000);

                        $.ajax({
                            url: form.attr('action'),
                            type: form.attr('method'),
                            data: ajaxData,
                            dataType: 'json',
                            cache: false,
                            contentType: false,
                            processData: false,
                            complete: function () {
                                $('#' + element_id + '-showroom__entry-' + unique_id +' .fxxl-rma-upload-showroom__entry--upload')
                                    .addClass('fxxl-hidden');
                            },
                            success: function (result) {
                                if (result.hasOwnProperty('data') && result.data) {
                                    var data = result.data;
                                    if (data.hasOwnProperty('error_messages') &&
                                        Object.entries(data.error_messages).length) {
                                        Object.values(data.error_messages).forEach(function (errorMessage) {
                                            $('#' + element_id + '-showroom__entry-' + unique_id +
                                                ' .fxxl-rma-upload-showroom__entry--upload')
                                                .addClass('fxxl-hidden');
                                            $('#' + element_id + '-showroom__entry-' + unique_id +
                                                ' .fxxl-rma-upload-showroom__entry--error')
                                                .removeClass('fxxl-hidden');
                                            $('#' + element_id + '-showroom__entry--uploaded_file' + unique_id).remove();
                                            M.toast({
                                                html: errorMessage,
                                                classes: 'fxxl-toast',
                                                displayLength: 2500
                                            });
                                        });
                                    } else {
                                        $('#' + element_id + '-showroom__entry-' + unique_id +
                                            ' .fxxl-rma-upload-showroom__entry--done')
                                            .removeClass('fxxl-hidden');
                                    }
                                }
                            },
                            error: function (xhr, textStatus) {
                                M.toast({
                                    html: textStatus,
                                    classes: 'fxxl-toast',
                                    displayLength: 2500
                                });
                            }
                        });
                     });
                    form.trigger('reset');
                }
            } else {
                var iframeName	= 'Fxxluploadiframe' + new Date().getTime(),
                    iframe		= $('<iframe name="' + iframeName + '" style="display: none;"></iframe>');

                iframe.setAttribute('name', iframeName);
                iframe.style.display = 'none';

                document.body.appendChild(iframe);
                form.setAttribute('target', iframeName);

                iframe.addEventListener('load', function () {
                    var data = JSON.parse(iframe.contentDocument.body.innerHTML);
                    container.removeClass('is-uploading' )
                    container.addClass( data.success == true ? 'is-success' : 'is-error' )
                    form.removeAttribute('target');
                    if( !data.success ) errorMsg.text = data.error;
                    iframe.parentNode.removeChild(iframe);
                });
            }
        });

        // Firefox focus bug fix for file input
        container.on( 'focus', function(){ container.addClass( 'has-focus' ); });
        container.on( 'blur', function(){ container.removeClass( 'has-focus' ); });
    });
}
import {FxxlAddressAutocomplete} from "@fxxl/address_autocomplete";

function fxxlSetupPersonPage() {
    new FxxlElementVersionControl('.fxxl-person-navigation', largViewportSize, function (val) {
        var navigation = $('.fxxl-person-navigation'),
            navigationTabsHideScrollbar = navigation.find('.fxxl-tabs-hide-scrollbar'),
            navigationList = navigation.find('.fxxl-person-navigation__list');

        if (isLargeViewport() === false) {
            if (val === 1) {
                new FxxlAutoScrollToSelectedTab(navigationList);
            }
            M.Tabs.init(navigationList[0]);
            navigationList.find('.tab>a').click(function () {
                window.location.href = $(this).attr('href');
            });
        } else {
            navigationTabsHideScrollbar.removeClass('fxxl-tabs-hide-scrollbar');
            fxxlCreatePersonDesktopNavigation(navigationList);
        }
    });

    const selectElement = document.getElementById('p_lkz');

    if (selectElement) {
        selectElement.addEventListener('change', function () {
            for (let i = 0; i < selectElement.options.length; i++) {
                selectElement.options[i].removeAttribute('selected');
            }

            const selectedOption = selectElement.options[selectElement.selectedIndex];
            selectedOption.setAttribute('selected', 'selected');
            new FxxlAddressAutocomplete();
        });
    }

    /**
     * Delivery Address
     */
    $('.fxxl-person-delivery-address').each(function () {
        fxxlPersonDeliveryAddressPage($(this));
    });

    /**
     * Set Touchscroll
     */
    var fxxlPersonProductCancelForm = $('.fxxl-person-product-order-form');
    if (fxxlPersonProductCancelForm.length > 0) {
        new FxxlTouchScroller(fxxlPersonProductCancelForm[0]);
    }

    new FxxlAddressAutocomplete();
}

function fxxlCreatePersonDesktopNavigation(list) {
    var outputHtml = '',
        item,
        text,
        icon,
        link,
        dataCy,
        activeClass = '',
        classList,
        itemCounterIcon = '';

    list.removeClass('tabs fxxl-tabs tabs-not-init-automatic').addClass('fxxl-person-navigation__list--desktop');

    list.find('li.tab>a').each(function () {
        item = $(this);
        text = item.html();
        icon = item.data('icon');
        link = item.attr('href');
        dataCy = item.data('cy') || '';
        classList = item[0].classList;

        if (item.hasClass('active')) {
            activeClass = ' fxxl-person-navigation__item--active';
        } else {
            activeClass = '';
        }

        if (classList.contains('fxxl-person__bewertungen')) {
            itemCounterIcon = '<span class="fxxl-person__icon-base js_counter_bewertung" data-counter=""></span>';
        } else {
            itemCounterIcon = '';
        }

        outputHtml += '<li><a data-cy="' + dataCy + '" href="' + link + '" class="fxxl-person-navigation__item' + activeClass + '">' +
            '<div class="fxxl-person-navigation__icon"><svg class="fxxl-svg-fix" width="24" height="24">' +
            '<use href="#' + icon + '" xlink:href="#' + icon + '"></use></svg></div>' +
            '<div class="fxxl-person-navigation__text">' + text + '</div>' + itemCounterIcon + '</li></a>';
    });

    list.html(outputHtml);
}

function fxxlPersonDeliveryCancel(element) {
    var modalBox = $('.fxxl-person-modal'),
        modalContent = modalBox.find('.fxxl-modal__content'),
        cancelContent = modalBox.find('.fxxl-person-product-order-form__content'),
        footerContent = modalBox.find('.fxxl-person-product-order-form__footer'),
        commandInput = modalBox.find('.fxxl-person-product-order-form__command'),
        stornoInfo = modalContent.find('.fxxl-person-product-order-form__storno_info'),
        mobileModalPadding = 15,
        modalContentPadding,
        selectCancelReasons,
        checkboxes,
        selectTemp,
        reasonId,
        containerTemp,
        hiddenInput,
        jQueryElement = $(element),
        itemsContainer = jQueryElement.closest('.fxxl-person-orders__items').clone(),
        form = $('.fxxl-person-product-order-form');

    itemsContainer.find('.fxxl-person-orders__item-image-container').removeAttr('href');
    itemsContainer.find('.fxxl-person-orders__item-inf-title').removeClass('fxxl-person-orders__item-inf-title--hover-link').removeAttr('href');
    stornoInfo.removeClass('fxxl-hidden');

    form.off();

    /**
     * fxxlPersonCancelCommandId ist öffentlich
     * /srv/www/applicas/dev/customer_fahrradxxl/custom/module/public/fxxl3/person/person_bestellstatus.tpl
     */
    commandInput.val(fxxlPersonCancelCommandId);
    itemsContainer.addClass('fxxl-person-popup');
    itemsContainer.find('.fxxl-person-orders__item[data-cancelable="0"]').remove();
    selectCancelReasons = itemsContainer.find('.fxxl-person-orders__item-cancel-reason-container select');
    checkboxes = itemsContainer.find('.fxxl-person-orders__item-checkbox');
    itemsContainer.find('.fxxl-person-orders__item-action, .fxxl-person-orders__item-status').remove();
    itemsContainer.find('.fxxl-person-orders__item-price').addClass('fxxl-person-orders__item-price--vertical-center');
    checkboxes.addClass('fxxl-person-orders__item-checkbox--show');
    cancelContent.html('');
    cancelContent.append(itemsContainer);
    footerContent.css('display', 'block');

    let zwDescription = modalContent.find('.js-fxxl-zwdescription');
    let reasonJobradContainer = modalContent.find('.fxxl-person-orders__item-cancel-reason-container_jobrad');
    let cancelButtonNonJobRad = modalContent.find('.js-fxxl-cancel-button-nonJobRad');
    let cancelButtonJobRad = modalContent.find('.js-fxxl-cancel-button-jobRad');
    zwDescription.addClass('fxxl-hidden');
    reasonJobradContainer.addClass('fxxl-hidden');
    cancelButtonNonJobRad.removeClass('fxxl-hidden');
    cancelButtonJobRad.addClass('fxxl-hidden');
    if (element.dataset.zahlungsweiseInternalDescription === 'fxxl_leasing_jobrad' &&  zwDescription.length) {
        let items = modalContent.find('.fxxl-person-orders__item-checkbox--show');
        if (items.length) {
            if (items.length > 1) {
                zwDescription.removeClass('fxxl-hidden');
            }
            let checkBox = items.find('input');
            if (checkBox.length) {
                checkBox.prop('checked', true);
                items.addClass('fxxl-hidden');
                reasonJobradContainer.removeClass('fxxl-hidden');
                cancelButtonNonJobRad.addClass('fxxl-hidden');
                cancelButtonJobRad.removeClass('fxxl-hidden');
                let selectCancelReasonsJobrad = reasonJobradContainer.find('select');
                selectCancelReasonsJobrad.on('change', function () {
                    selectTemp = $(this);
                    reasonId = selectTemp.find('option[value="' + selectTemp.val() + '"]').data('select-id');
                    modalContent.find('.jsFxxlProductList').each(function() {
                        hiddenInput = $(this);
                        let jsonString = JSON.stringify(
                            {
                                pos_id: hiddenInput.data('pos-id'),
                                status_id: hiddenInput.data('status-id'),
                                reason_value: selectTemp.val(),
                                reason_id: reasonId
                            }
                        );
                        hiddenInput.val(jsonString);
                    });
                });
                new FxxlFormValidation(selectCancelReasonsJobrad);
            }
        }
        stornoInfo.addClass('fxxl-hidden');
    }

    fxxlUpdatePersonDeliveryButton(cancelContent);
    fxxlPersonDeliveryCheckboxes(checkboxes, 'cancel');

    selectCancelReasons.on('change', function () {
        selectTemp = $(this);
        reasonId = selectTemp.find('option[value="' + selectTemp.val() + '"]').data('select-id');
        containerTemp = selectTemp.closest('.fxxl-person-orders__item-cancel-reason-container');
        hiddenInput = containerTemp.find('input[type="hidden"]');
        hiddenInput.val('{"pos_id":' + hiddenInput.data('pos-id') + ',' + '"status_id":' + hiddenInput.data('status-id') + ',"reason_value":"' + selectTemp.val() + '", "reason_id" : ' + reasonId + '}');
    });

    selectCancelReasons.each(function () {
        new FxxlFormValidation($(this));
    });

    const modalBoxInstance = M.Modal.init(modalBox[0]);
    modalBoxInstance.open();

    if (isLargeViewport() === false) {
        modalContent.css({'padding': mobileModalPadding + 'px'});
        modalContentPadding = (mobileModalPadding * 2) - 1;
        form.height(window.innerHeight - ((modalBox.find('.fxxl-modal__header').height()) + modalContentPadding));
    }

    form.on('submit', function () {

        var errorBlock = $('.fxxl-person-orders__item-cancel-reason-container--show .fxxl-person-orders__item-error, .fxxl-person-orders__item-cancel-reason-container_jobrad .fxxl-person-orders__item-error');
        var hasError = false;
        errorBlock.each(function () {
            if ($(this).css('display') == 'block') {
                hasError = true;
            }
        });
        if (!hasError) {
            showSpinner();
        }
    });
}

function fxxlPersonDeliveryCheckboxes(el, art) {
    var checkbox,
        item;

    if (art != 'cancel') {
        art = 'return';
    } else {
        art = 'cancel';
    }

    el.on('change', function () {
        checkbox = $(this).find('input[type="checkbox"]');
        item = checkbox.closest('.fxxl-person-orders__item');
        if (checkbox.is(':checked') === true) {
            item.find('.fxxl-person-orders__item-' + art + '-reason-container').addClass('fxxl-person-orders__item-' + art + '-reason-container--show');
            item.find('.fxxl-person-orders__item-' + art + '-reason-container select').change();
        } else {
            item.find('.fxxl-person-orders__item-' + art + '-reason-container').removeClass('fxxl-person-orders__item-' + art + '-reason-container--show');
            item.find('.fxxl-person-orders__item-' + art + '-reason-container input[type="hidden"]').val('');
        }
        fxxlUpdatePersonDeliveryButton($(this));
    });
}

function fxxlPersonReturnSelects(selects) {
    selects.each(function () {
        $(this).change(function () {
            const posId = $(this).data('pos-id');
            const selected = $(this).find('option:selected');

            if (selected.data('required_img') == 1) {
                $('#fxxl-person-orders__item-return-reason-container_img-' + posId).removeClass('fxxl-hidden');
                $('.fxxl-person-product-order-form').animate({ scrollTop: $('#frmRetourn').height() }, 1000);
            } else {
                $('#fxxl-person-orders__item-return-reason-container_img-' + posId).addClass('fxxl-hidden');
            }

            if (selected.data('required_text') == 1) {
                $('#fxxl-person-orders__item-return-reason-container_text-' + posId).removeClass('fxxl-hidden');
            } else {
                $('#fxxl-person-orders__item-return-reason-container_text-' + posId).addClass('fxxl-hidden');
            }
        });
        new FxxlFormValidation($(this));
    });
}

function fxxlPersonReturnResetSelects() {
    $('[id^="fxxl-person-orders__item-return-reason-container_img-"]').addClass('fxxl-hidden');
    $('[id^="fxxl-person-orders__item-return-reason-container_text-"]').addClass('fxxl-hidden');
}

function fxxlUpdatePersonDeliveryButton(el) {
    var form = el.closest('.fxxl-person-product-order-form'),
        AdressElement = $('.fxxl-person-product-order-form__content-adress'),
        button = form.find('.fxxl-person-product-order-form__footer-button'),
        countElement = button.find('.fxxl-person-product-order-form__footer-count'),
        selectedCount = form.find('.fxxl-person-orders__item-checkbox input[type="checkbox"]:checked').length,
        modal = form.closest('.fxxl-modal--mobile-fullscreen.open');

    if (selectedCount === 0) {
        button.prop('disabled', true);
        countElement.removeClass('fxxl-person-product-order-form__footer-count--show');
        AdressElement.addClass('fxxl-hidden');
        modal.css({overflow: ''});
    } else {
        countElement.text(selectedCount);
        button.prop('disabled', false);
        countElement.addClass('fxxl-person-product-order-form__footer-count--show');
        AdressElement.removeClass('fxxl-hidden');
        modal.css('overflow', 'hidden');
    }
}

function fxxlPersonDeliveryAddressPage(element) {
    /**
     * selectedDeliveryAddresses ist öffentlich
     * /srv/www/applicas/dev/customer_fahrradxxl/custom/module/public/fxxl3/person/person_lanschrift.tpl
     */
    var addressSelector = element.find('.fxxl-person-delivery-address__list-select select'),
        delivery_address_remove_button = element.find('.fxxl-person-delivery-address__button--delete'),
        deliveryFormMode = element.find('#la_mode'),
        deliveryForm = element.find('#frmLa');

    addressSelector.val(selectedDeliveryAddresses);

    addressSelector.on('change', function () {
        selectedDeliveryAddresses = parseInt(addressSelector.val());
        fxxlPersonSetDeliveryAddressData();
    });

    delivery_address_remove_button.on('click', function () {
        deliveryFormMode.val(1);
        deliveryForm.submit();
        return false;
    });

    /**
     * Show Hide Input: Firma
     */
    $('input[name="la_anrede"]').on('change', function () {
        fxxlDeliveryAddressShowHideFirma($(this).val());
    });

    if ($('#la_saved_id').val() === '-1') {
        $('.fxxl-person-meinedaten__la-form-fields').addClass('fxxl-hidden');
    } else {
        $('.fxxl-person-meinedaten__la-form-fields').removeClass('fxxl-hidden');
        fxxlPersonSetDeliveryAddressData();
    }

    return true;
}

function fxxlSetInvoiceToDeliveryAddress()
{
    let laName1 = $('#la_name1');
    if ($('#la_saved_id').val() === '-1') {
        $('#frmLa input[type!="hidden"][type!="radio"]').each(function (element) {
            const deliveryElement = $(this);
            let invoiceElement = $('#' + deliveryElement.attr('id')?.replace('la_', 'p_'));
            deliveryElement.attr('disabled', 'disabled');
            if (invoiceElement.length) {
                deliveryElement.val(invoiceElement.val());
                FxxlCore.eventEmitter('change').emit(null, laName1[0]);
            }
        });

        let anredeValue = $('[name="p_anrede"]').val();
        let laAnrede = $('[name="la_anrede"][value="' + anredeValue + '"]');
        if (laAnrede.length) {
            laAnrede.prop("checked", true);
            $('[name="la_anrede"]').attr('disabled', 'disabled');
            if (anredeValue === '3') {
                laName1.closest('div').removeClass('fxxl-hidden');
                laName1.val($('#o_name1').val());
                FxxlCore.eventEmitter('change').emit(null, laName1[0]);
            } else {
                $('#la_name1').closest('div').addClass('fxxl-hidden');
            }
        }
        $('#la_save').addClass('fxxl-hidden');
    }
}


function fxxlDeliveryAddressShowHideFirma(anrede_value) {
    if (+anrede_value === 3) {
        $('.fxxl-person-delivery-address__input--company-name').removeClass('fxxl-hidden');
    } else {
        $('.fxxl-person-delivery-address__input--company-name').addClass('fxxl-hidden');
    }
}

function fxxlPersonSetDeliveryAddressData() {
    var data = fxxlPersonGetDeliveryAddressData(),
        delivery_address_remove_button = $('.fxxl-person-delivery-address__button--delete'),
        delivery_title_element = $('[name="la_anrede"]'),
        delivery_firstname_element = $('[name="la_vorname"]'),
        delivery_lastname_element = $('[name="la_nachname"]'),
        delivery_companyname_element = $('[name="la_name1"]'),
        delivery_zip_element = $('[name="la_plz"]'),
        delivery_place_element = $('[name="la_ort"]'),
        delivery_street_element = $('[name="la_strasse"]'),
        delivery_streen_number_element = $('[name="la_hausnummer"]'),
        delivery_address_more_element = $('[name="la_name2"]'),
        delivery_lalkz_element = $('[name="la_lkz"]');

    /**
     * fxxlActiveValidationTest ist öffentlich
     * /srv/www/applicas/dev/customer_fahrradxxl/custom/module/public/fxxl3/assets/js/400_form_validation.js
     * @type {boolean}
     */
    fxxlActiveValidationTest = false;

    if ($('#la_saved_id').val() === '-1') {
        $('.fxxl-person-meinedaten__la-form-fields').addClass('fxxl-hidden');
    } else {
        $('.fxxl-person-meinedaten__la-form-fields').removeClass('fxxl-hidden');
        $('#la_save').removeClass('fxxl-hidden');
        if (data === false) {
            delivery_address_remove_button.hide();
            delivery_title_element.prop('checked', false).removeAttr('disabled');
            delivery_firstname_element.val('').removeAttr('disabled').blur();
            delivery_lastname_element.val('').removeAttr('disabled').blur();
            delivery_companyname_element.val('').removeAttr('disabled').blur();
            delivery_zip_element.val('').removeAttr('disabled').blur();
            delivery_place_element.val('').removeAttr('disabled').blur();
            delivery_street_element.val('').removeAttr('disabled').blur();
            delivery_streen_number_element.val('').removeAttr('disabled').blur();
            delivery_address_more_element.val('').removeAttr('disabled').blur();
            delivery_lalkz_element.removeAttr('disabled').blur();

            delivery_firstname_element[0].fxxl_form_validation_object.clearIcons();
            delivery_lastname_element[0].fxxl_form_validation_object.clearIcons();
            delivery_companyname_element[0].fxxl_form_validation_object.clearIcons();
            delivery_zip_element[0].fxxl_form_validation_object.clearIcons();
            delivery_place_element[0].fxxl_form_validation_object.clearIcons();
            delivery_street_element[0].fxxl_form_validation_object.clearIcons();
            delivery_streen_number_element[0].fxxl_form_validation_object.clearIcons();
            delivery_address_more_element[0].fxxl_form_validation_object.clearIcons();
            delivery_lalkz_element[0].fxxl_form_validation_object.clearIcons();

            fxxlDeliveryAddressShowHideFirma(0);
        } else {
            delivery_address_remove_button.show();
            delivery_title_element.filter('[value="' + data.anrede + '"]').prop('checked', true);
            delivery_firstname_element.val(data.vorname);
            FxxlCore.eventEmitter('change').emit(null, delivery_firstname_element[0]);

            delivery_lastname_element.val(data.nachname);
            FxxlCore.eventEmitter('change').emit(null, delivery_lastname_element[0]);

            delivery_companyname_element.val(data.name1);
            FxxlCore.eventEmitter('change').emit(null, delivery_companyname_element[0]);

            delivery_zip_element.val(data.plz);
            FxxlCore.eventEmitter('change').emit(null, delivery_zip_element[0]);

            delivery_place_element.val(data.ort);
            FxxlCore.eventEmitter('change').emit(null, delivery_place_element[0]);

            delivery_street_element.val(data.strasse);
            FxxlCore.eventEmitter('change').emit(null, delivery_street_element[0]);

            delivery_streen_number_element.val(data.hausnummer);
            FxxlCore.eventEmitter('change').emit(null, delivery_streen_number_element[0]);

            delivery_address_more_element.val(data.name2);
            FxxlCore.eventEmitter('change').emit(null, delivery_address_more_element[0]);

            fxxlDeliveryAddressShowHideFirma(data.anrede);
        }
    }

    fxxlActiveValidationTest = true;
}

function fxxlPersonGetDeliveryAddressData() {
    /**
     * deliveryAddresses und selectedDeliveryAddresses sind öffentlich
     * /srv/www/applicas/dev/customer_fahrradxxl/custom/module/public/fxxl3/person/person_lanschrift.tpl
     */
    var result = false;
    $.each(deliveryAddresses, function (index, data) {
        if (parseInt(data.b_lieferanschrift_id) === selectedDeliveryAddresses) {
            result = data;
        }
    });
    return result;
}

function fxxlPersonInvoiceAddressPage(element) {
    var prefix = 'fxxl-person-invoice-address__input';

    element.find('[name="p_anrede"]').on('change', function () {
        fxxlPersonSetupAddressFirma(element, prefix);
    });
    fxxlPersonSetupAddressFirma(element, prefix);
}

function fxxlPersonRegisterAddressPage(element) {
    var prefix = 'fxxl-person-register__input';
    element.find('[name="p_anrede"]').on('change', function () {
        fxxlPersonSetupAddressFirma(element, prefix);
    });
    fxxlPersonSetupAddressFirma(element, prefix);
}


function fxxlPersonSetupAddressFirma(element, prefix) {
    var firmaBox = element.find('.' + prefix + '--company'),
        firmaInput = firmaBox.find('input'),
        selectedElement = element.find('[name="p_anrede"]'),
        selectedTitle,
        animateSpeed = 150,
        ease = 'easeOutCirc',
        validationDisabled = true;

    if (selectedElement[0].tagName === 'SELECT') {
        selectedTitle = parseInt(selectedElement.val());
    } else {
        selectedTitle = parseInt(selectedElement.filter(':checked').val());
    }

    if (selectedTitle === 3) {
        validationDisabled = false;
        firmaBox.animate({opacity: 1, 'height': '50px', 'padding': '5px'}, animateSpeed, ease, function () {
            firmaBox.css({'overflow': '', 'height': 'auto'});
        });
    } else {
        firmaBox.css({'overflow': 'hidden'});
        firmaBox.animate({opacity: 0, 'height': '0', 'padding': '0'}, animateSpeed, ease);
    }

    if (firmaInput[0]?.fxxl_form_validation_object !== undefined) {
        firmaInput[0].fxxl_form_validation_object.validationDisabled = validationDisabled;
    }
}

$('.js-fxxl-person-orders-jobRadPdf').on('click', function () {
    let belegId = $(this).data('belegId');
    if (belegId !== undefined) {
        let url = '/json.php?service=getJobRadPdf&belegId=' + belegId;
        $.getJSON(url,
            function (response) {
                if (response.urlJobRadPdf !== undefined && response.urlJobRadPdf !== '') {
                    let link = document.createElement("a");
                    link.href = response.urlJobRadPdf;
                    link.setAttribute("download", 'JobRad.pdf');
                    link.click();
                }
            }
        );
    }
});

if (site_type === 'person' && site_name === 'bewertung') {

    let orderItems = $('.fxxl-person-orders__items');

    orderItems.each((index, element) => {
        if ($(element).children().length === 0) {
            $(element).parent().addClass('fxxl-hidden');
        }
    });

    $('.js-rating-form-toggle').on('click', function () {
        let personRatingModal,
            artikelNumber = $(this).data('artnr'),
            productId = $(this).data('pid'),
            mainProductId = $(this).data('mpid'),
            productTitle = $(this).data('title'),
            productColor = $(this).data('color'),
            productSize = $(this).data('size'),
            productImage = $(this).data('image'),
            productBelegId = $(this).data('belegid'),
            orderId =  $(this).data('orderid'),
            urlParameterOrderId = getURLParam("varid", window.location.href),
            ratingForm = $('#fxxl-element-rating-form-1'),
            formActionUrl,
            formUrl,
            reviewedProductInput = $('#reviewed_product_id'),
            reviewedArtikelNumber = $('#reviewed_product_number'),
            reviewProductSizeVisibilityInput = $('#reviewed_product_size_visible'),
            reviewProductBelegIdInput = $('#reviewed_beleg_pos_id'),
            reviewedByUserInput = $('#reviewed_by_buyer'),
            formInputName = ratingForm.find('input[name="first_name"]'),
            formInputEmail = ratingForm.find('input[name="email"]'),
            variantTitle = $('.fxxl-element-rating-form__variants-desc-title'),
            variantColor = $('.fxxl-element-rating-form__variants-desc-color'),
            variantSize = $('.fxxl-element-rating-form__variants-desc-size'),
            variantImage = $('.fxxl-element-rating-form__variants-image');

        if (pvdRatingModalId !== undefined) {
            if (personRatingModal === undefined) {
                personRatingModal = M.Modal.init($('#' + pvdRatingModalId)[0], {});
            }

            if (personRatingModal.isOpen === true) {
                personRatingModal.close();
            } else {
                personRatingModal.open();
            }

            if (ratingForm) {
                formActionUrl = window.location.protocol + '//' + window.location.host + ratingForm.attr('action');
                formUrl = new URL(formActionUrl);
                formUrl.searchParams.set('oid', mainProductId);
                ratingForm.attr('action', formUrl.pathname + formUrl.search);
                ratingForm.attr('name', 'ratingForm' + mainProductId);
                // Alle Felder erst mal leeren, da im Kundenkonto ansonsten die bereits eingegeben Daten bei einer neuen Bewertung wieder angezeigt werden (Modal zu und dann wieder auf).
                let fields = ratingForm.find('input[type!="file"], select, textarea').not('[name^="privacyrule"]');
                if (fields.length) {
                    fields.each(function () {
                        let field = $(this);
                        if (field.hasClass('fxxl-element-set-rating-stars__input')) {
                            field.prop('checked', false);
                        } else {
                            field.val('');
                        }
                    });
                }

                // function in 510_save_and_load_form.js
                loadAndSaveDataForm(ratingForm);
            }

            if (reviewedProductInput) {
                reviewedProductInput.val(productId);
            }

            if (reviewedArtikelNumber) {
                reviewedArtikelNumber.val(artikelNumber);
            }

            if (reviewProductSizeVisibilityInput) {
                reviewProductSizeVisibilityInput.val(1);
            }

            if (reviewProductBelegIdInput) {
                reviewProductBelegIdInput.val(productBelegId);
            }

            if (formInputName && formInputEmail && typeof FxxlPersonalData !== 'undefined') {
                if (FxxlPersonalData.user !== undefined) {
                    if (FxxlPersonalData.user.loggedIn) {
                        if (formInputName.val() === '') {
                            formInputName.val(FxxlPersonalData.user.firstName).focus();
                        }
                        if (formInputEmail.val() === '') {
                            formInputEmail.val(FxxlPersonalData.user.Email).focus();
                        }
                        formInputEmail.blur();
                        if (reviewedByUserInput) {
                            reviewedByUserInput.val('1');
                        }
                    } else {
                        if (typeof _personVorname !== 'undefined' && typeof _personEmail !== 'undefined' && _personVorname && _personEmail) {
                            if (formInputName.val() === '') {
                                formInputName.val(_personVorname).focus();
                            }
                            if (formInputEmail.val() === '') {
                                formInputEmail.val(_personEmail).focus();
                            }
                            formInputEmail.blur();
                        }
                    }
                }
            }

            if (urlParameterOrderId !== null && parseInt(urlParameterOrderId) === orderId) {
                if (reviewedByUserInput) {
                    reviewedByUserInput.val('1');
                }
            }

            // set variant info
            variantTitle.html('').html(productTitle);
            variantColor.html('').html(productColor);
            variantSize.html('').html(' | ' + productSize);
            variantImage.html('').append(productImage);
        }
    });

    /**
     * Triggert das Belegposition bewertungsformular, wenn es von Produktbewertungs-E-Mail weitergeleitet wird
     */
    let openBelegPositionRatingForm = getURLParam('fxxl_open_produktbewertung', window.location.href),
        belegPositionId = getURLParam('beleg_pos_id', window.location.href),
        openBelegRatingModalButton = document.querySelector('[data-belegid="' + belegPositionId + '"]');

    if (openBelegPositionRatingForm === '1' && openBelegRatingModalButton !== null) {
        setTimeout(() => {
            openBelegRatingModalButton.click();
            let newUrl = fxxlRemoveURLParameter(location.href, 'fxxl_open_produktbewertung');
            window.history.pushState({}, null, newUrl);
        }, 250);
    }
}
/**
 * Jquery ease (easeOutCirc)
 */
jQueryEase();

/**
 * Setup Person List
 */
if ($('.fxxl-person-navigation').length > 0) {
    fxxlSetupPersonPage();
}

/**
 * Person Delivery Address Page
 */
$('.fxxl-person-delivery-address').each(function () {
    fxxlPersonDeliveryAddressPage($(this));
});

/**
 * Person Invoice Address Page
 */
$('.fxxl-person-invoice-address').each(function () {
    fxxlPersonInvoiceAddressPage($(this));
});

/**
 * Person Invoice Address Page
 */
$('.fxxl-person-register').each(function () {
    fxxlPersonRegisterAddressPage($(this));
});
FxxlCore.externalUseableObject('fxxlPersonReturnResetSelects', fxxlPersonReturnResetSelects);
FxxlCore.externalUseableObject('fxxlPersonDeliveryCheckboxes', fxxlPersonDeliveryCheckboxes);
FxxlCore.externalUseableObject('fxxlPersonDeliveryCancel', fxxlPersonDeliveryCancel);
FxxlCore.externalUseableObject('fxxlPersonReturnSelects', fxxlPersonReturnSelects);
FxxlCore.externalUseableObject('FxxlLoadUpload', FxxlLoadUpload);